import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('CompanyPlatform', CompanyPlatform);

    /* @ngInject */
    function CompanyPlatform() {
        CompanyPlatform.prototype = {
            build: build,
            buildEmpty: buildEmpty,
        };

        function CompanyPlatform(platform) {
            if (!platform) {
                this.buildEmpty();
            } else {
                this.build(platform);
            }
        }

        return CompanyPlatform;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.family = null;
            this.invoiceEm = false;
            this.invoiceRe = false;
            this.platformEid = null;
        }

        function build(platform) {
            this.id = platform.id || null;
            this.family = platform.family || null;
            this.invoiceEm = platform.invoiceEm || false;
            this.invoiceRe = platform.invoiceRe || false;
            this.platformEid = platform.platformEid || null;
        }
    }
})();
